import { useLocation, useNavigate } from "react-router-dom";
import { Box, Divider, Grid, Paper, Stack, Typography, IconButton } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import React, { useState } from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SEO from "../SEO";

const MobileServiceGuideDetailsItem = () => {
  const location = useLocation();
  if (!location.state) {
    nav("/services-guide");
  }
  const currencyName = location.state?.currency?.[0].name;
  const {
    name,
    applicationFee,
    compilationTime,
    isPdfExist,
    requiredAttachments,
    pdfPath,
  } = location.state;
  const nav = useNavigate();

  const openPdf = () => {
    window.open(pdfPath, "_blank");
  };

  return (
    <>
    <SEO title={name} />
    <Paper sx={{ p: 3, borderRadius: "10px" }} elevation={5}>
      <Stack gap={2}>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "10px",
            border: "2px solid",
            borderColor: "success.main",
            boxShadow: "0px 4px 12px rgba(76, 175, 80, 0.15)",
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "success.main" }}>
            رسوم الطلب: {applicationFee} {currencyName}
          </Typography>
        </Paper>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            px: 3,
            borderRadius: "10px",
            border: "2px solid",
            borderColor: "primary.main",
            boxShadow: "0px 4px 12px rgba(25, 118, 210, 0.15)",
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "primary.main" }}>
            {`الوقت اللازم لإنجاز الطلب: ${compilationTime ? `${compilationTime} ايام` : ""}`}
          </Typography>
        </Paper>
        <Paper
          elevation={2}
          sx={{
            background: "#fff",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            py: 2,
            px: 3,
            borderRadius: "10px",
            border: "2px solid",
            borderColor: "error.main",
            boxShadow: "0px 4px 12px rgba(211, 47, 47, 0.15)",
            "& .MuiButtonBase-root": {
              padding: 0,
            },
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "error.main" }}>دليل الخدمة :</Typography>
          <IconButton
            color={"error"}
            disabled={!isPdfExist}
            onClick={openPdf}
          >
            <PictureAsPdfIcon sx={{ padding: 0 }} />
          </IconButton>
        </Paper>

        {requiredAttachments.map((t, i) => {
          return (
            <Paper sx={{ width: "100%", mt: 2, p: 3 }} elevation={5}>
              <Stack sx={{ width: "100%", gap: 2 }}>
                <Box gap={2} display="flex">
                  <Typography>نوع&nbsp;المرفق:</Typography>
                  <Typography>{t.attachmentType}</Typography>
                </Box>
                <Divider />
                <Box gap={2} display="flex">
                  <Typography>اجباري</Typography>
                  {t.isMandatory && (
                    <CheckCircleOutlineOutlinedIcon htmlColor="#32CE37" />
                  )}
                </Box>
                <Divider />

                <Box gap={2} display="flex">
                  <Typography>اختياري</Typography>
                  {!t.isMandatory && (
                    <CheckCircleOutlineOutlinedIcon htmlColor="#32CE37" />
                  )}
                </Box>
              </Stack>
            </Paper>
          );
        })}
      </Stack>
    </Paper>
    </>
  );
};
export default MobileServiceGuideDetailsItem;
